import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["validateSchema"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Form as FinalForm } from 'react-final-form';
import { validator } from './form.helper';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Form component.
 *
 * @author Mikhail Siutsou
 * @function Form
 * @category components
 * @return {JSX.Element} button group component.
 */
export function Form(_ref) {
  var validateSchema = _ref.validateSchema,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var validate = validateSchema && validator(validateSchema);
  return /*#__PURE__*/_jsx(FinalForm, _objectSpread({
    validate: validate
  }, restProps));
}